export const badRequest = {
  error: "Une erreur inconnue est survenue !",
};
